import React from 'react';
import { CircularProgress } from '@material-ui/core';

const GlossaryList = ({
  search,
  selectedLetters,
  glossary,
  isLoading
}: any) => {
  const filteredGlossary = glossary.filter((entry: any) => {
    // Convert the search term and entry term to lowercase for case-insensitive comparison
    const searchLower = search.toLowerCase();
    const termLower = entry.term?.toLowerCase();

    // Check if the entry's term matches or contains the search term (e.g., "Alpha" for "Alpha (1Y)")
    const matchesSearch =
      termLower?.includes(searchLower) || searchLower?.includes(termLower);

    // Check if the entry's term starts with any of the selected letters
    const matchesLetter =
      selectedLetters.length === 0 ||
      selectedLetters.some((letter: any) =>
        termLower.startsWith(letter.toLowerCase())
      );

    return matchesSearch && matchesLetter;
  });

  return (
    <>
      {isLoading ? (
        <CircularProgress />
      ) : (
        <>
          {filteredGlossary.length > 0 ? (
            [...filteredGlossary]
              .sort((a: any, b: any) =>
                a.term.toLowerCase() > b.term.toLowerCase() ? 1 : -1
              )
              .map((entry: any, index: number) => (
                <div key={index}>
                  <h2>{entry.term}</h2>

                  <div
                    dangerouslySetInnerHTML={{ __html: entry.definition }}
                    style={{ whiteSpace: 'pre-wrap' }}
                  />
                </div>
              ))
          ) : (
            <div>No results found</div>
          )}
        </>
      )}
    </>
  );
};

export default GlossaryList;
